import { render } from "./success.vue?vue&type=template&id=13ac1fd2&scoped=true"
const script = {}

import "./success.vue?vue&type=style&index=0&id=13ac1fd2&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ac1fd2"]])

export default __exports__